import { Equipo } from '@/types/tda';
import { cn } from '@/utils';

const ItemRanking = ({ data }: { data: Equipo }) => {
  return (
    <div>
      <div className="flex justify-stretch bg-white border-b-gdt-gray-6 border-b-[1px] px-7 lg:py-6 text-xs font-semibold text-gdt-gray-3 py-4">
        <div className="w-12 lg:w-[68px]">
          <div
            className={cn(
              'rounded-full bg-gdt-blue text-white w-9 h-9 lg:w-10 lg:h-10 font-bold text-lg flex justify-center items-center',
              { 'text-gdt-blue bg-gdt-blue-light2': data.nroPos !== 1 }
            )}
          >
            <span>{data.nroPos}</span>
          </div>
        </div>
        <div className="flex-1 space-y-1">
          <p className="font-bold text-gdt-gray">{data.dt}</p>
          <p className="font-bold text-[12px] text-[#717077]">{data.equipo}</p>
        </div>
        <p className="w-[62px] text-[18px] text-right lg:w-[113px] lg:text-center">
          {data.puntos}
        </p>
      </div>
    </div>
  );
};

export default ItemRanking;
